import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Modal from 'react-modal'

import ModalCloseButton from '../../ModalCloseButton'
import PartyAvailableModalCta from './PartyAvailableModalCta'
import PartyAvailableModalDetails from './PartyAvailableModalDetails'

import * as cross from '../../../store/cross'
import * as pdp from '../../../store/productDetailPage'

import {closePartyAvailableModal} from '../../../actions/productDetailPage'

import '../../../../scss/components/_party-available-modal.scss'

function PartyAvailableModal(props) {
  if (!props.isPartyAvailable) {
    return (
      <Modal
        className="party-available-modal-container"
        overlayClassName="modal-overlay"
        isOpen={props.partyAvailableModalIsOpen}
        onRequestClose={props.closePartyAvailableModal}
        contentLabel="Modal"
      >
        <div>
          <PartyAvailableModalDetails />
          <PartyAvailableModalCta />
          <ModalCloseButton onClick={props.closePartyAvailableModal} />
        </div>
      </Modal>
    )
  }
  return null
}

PartyAvailableModal.propTypes = {
  closePartyAvailableModal: PropTypes.func.isRequired,
  partyAvailableModalIsOpen: PropTypes.bool.isRequired,
  isPartyAvailable: PropTypes.bool.isRequired,
}

function mapStateToProps(state) {
  return {
    partyAvailableModalIsOpen: pdp.partyAvailableModalIsOpen(state),
    isPartyAvailable: cross.isPartyAvailable(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    closePartyAvailableModal: () => dispatch(closePartyAvailableModal()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PartyAvailableModal)
